import {
  menu_item_base_styles_default
} from "./chunk.MKVWGLNN.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/menu-item/menu-item.styles.ts
var menu_item_styles_default = r` ${component_styles_default} ${menu_item_base_styles_default} /** Menu orientation support */ :host(.menu-horizontal--menu-item) .menu-item { border-radius: var(--sl-border-radius-pill); min-height: 32px; } :host(.menu-horizontal--menu-item) .menu-item .menu-item__label { flex: 1 1 auto; padding: 0 var(--sl-spacing-medium); } :host(.menu-horizontal--menu-item) .menu-item .menu-item__prefix ::slotted(*) { margin-left: 0; } :host(.menu-horizontal--menu-item) .menu-item--has-submenu .menu-item__label { padding-right: var(--sl-spacing-x-small); } /** Drawer Support */ :host(.drawer-menu-item) .menu-item__label { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; transition: 0.3s all ease; } :host(.drawer-menu-item) .menu-item__suffix { display: none; } :host(.drawer-menu-item:not(.drawer-menu-item--open)) .menu-item__chevron { display: none; } :host(.drawer-menu-item.drawer-menu-item--open) .menu-item__label { opacity: 1; width: auto; } :host(.drawer-menu-item:not(.drawer-menu-item--open)) .menu-item__label { opacity: 0; width: 0; } `;

export {
  menu_item_styles_default
};
